// de strings for messages/home.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const home: Dict = {
  "home.seo.title": "Jammable | Erstelle KI-Cover mit deinen Lieblingsstimmen!",
  "home.seo.description":
    "Erstelle KI-Cover in Sekunden mit Jammable: Tausende KI-Stimmen aus der Community, bereit für deine kreativen Projekte.",
  "home.seo.ogTitle":
    "Jammable | KI-Cover mit deinen Lieblingsstimmen | Musik mit KI erstellen",
  "home.seo.imageAlt": "Jammable - KI-Cover erstellen",

  // h1: "Erstelle <KI-Cover> mit deinen Lieblingsstimmen"
  "home.hero.views":
    "Über 10 Milliarden Aufrufe auf TikTok, YouTube und Instagram",
  "home.hero.titleBefore": "Erstelle",
  "home.hero.titleHighlight": "KI-Cover",
  "home.hero.titleAfter": "mit deinen Lieblingsstimmen",
  "home.hero.subtitle":
    "Wähl aus über 100.000 KI-Stimmen, füg dein Audio hinzu und erhalte es in Sekunden zurück.",
  "home.hero.decorVoice": "KI-Stimme",
  "home.hero.decorCover": "Cover",
  "home.hero.searchLabel": "Stimmen suchen",
  "home.hero.searchPlaceholder": "Über 100.000 Stimmen durchsuchen",
  "home.hero.searchButton": "Suchen",
  "home.hero.makeCover": "Cover erstellen",

  "home.categories.all": "Alle Kategorien",
  "home.recent": "Weitermachen",
  "home.trending": "Gerade im Trend",
  "home.seeAll": "Alle ansehen",

  // "Trainiere deine eigene <KI-Stimme>"
  "home.train.kicker": "Über 100.000 Stimmen haben so angefangen",
  "home.train.titleBefore": "Trainiere deine eigene",
  "home.train.titleHighlight": "KI-Stimme",
  "home.train.body":
    "Erstelle aus ein paar Aufnahmen eine Stimme und mach Cover mit einer Stimme, die sonst niemand hat.",
  "home.train.step1": "Aufnahmen hochladen",
  "home.train.step1Sub": "Ein kurzer Clip mit klarem Gesang reicht",
  "home.train.step2": "Wir trainieren dein Modell",
  "home.train.step2Sub": "Deine eigene Stimme ist in Minuten fertig",
  "home.train.step3": "Cover damit erstellen",
  "home.train.step3Sub": "Nutz sie für deine Cover, wann immer du willst",

  "home.topCollections": "Top-Sammlungen",
  "home.collabs": "Angesagte Collabs",
  "home.collection": "Sammlung",

  "home.card.uses": "{n} Nutzungen",
  "home.card.voices": "{n} Stimmen",
  "home.card.likes": "{n} Likes",
  "home.card.by": "von @{user}",
  "home.card.madeToday": "{n} heute erstellt",
  "home.card.makeDuet": "Dieses Duett erstellen",

  "home.discord.bannerSub":
    "Teile Cover, wünsch dir Stimmen und hol dir Hilfe aus der Community",
  "home.discord.online": "{n} online",
  "home.discord.members": "{n} Mitglieder",
  "home.discord.joinDiscord": "Discord beitreten",
  "home.discord.softSub": "Cover teilen, Stimmen wünschen, Tipps holen",
  "home.discord.cardSub": "Hilfe holen, Cover teilen, neue Stimmen finden",
  "home.discord.join": "Beitreten",
};

export default home;
